import { render, staticRenderFns } from "./emojiPickerVue.vue?vue&type=template&id=1740204c"
import script from "./emojiPickerVue.vue?vue&type=script&lang=ts"
export * from "./emojiPickerVue.vue?vue&type=script&lang=ts"
import style0 from "./emojiPickerVue.vue?vue&type=style&index=0&id=1740204c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports